import { SVGProps } from "react";

const STIWindows = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-label="Windows" role="img" viewBox="0 0 512 512" width="1em" height="1em" {...props}><rect width={512} height={512} rx="15%" fill="#00adef" /><path fill="#fff" d="M98 145V250H225V127m15-2V250H408V101M98 368V263H225V386m15 1V263H408V411" /></svg>;

export { STIWindows };